export default "__VITE_ASSET__Cgy_hFRf__"